import {
    ChangeDetectionStrategy, ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild
} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {ZXingScannerComponent} from '@zxing/ngx-scanner';
import BarcodeFormat from '@zxing/library/esm/core/BarcodeFormat';
import {CommonFunctionsService} from '../../../services/common-functions.service';

/*  Inv Labels: 10 Stellen 'i2of5_reader'
    GTIN: EAN 8 oder 13 Stellen 'code_128_reader' UPC, UPC-A 12 Stellen
 */

@Component({
    selector: 'app-barcode-scanner',
    templateUrl: './barcode-scanner.component.html',
    styleUrls: ['./barcode-scanner.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BarcodeScannerComponent implements OnInit, OnDestroy {

    @Input() iconHeight = '300px';
    @Input() iconWidth = '400px';
    @Input() liveHeight = '300px';
    @Input() liveWidth = '400px';
    @Input() autoStart = false;
    @Input() type = 'inv'; // or 'ean' or 'ser'
    @Output() code = new EventEmitter<string>();

    @ViewChild('scanner', {static: false}) scanner!: ZXingScannerComponent;

    public loading = false;
    public allowedFormats: number[] = [];
    public scannerEnabled = false;
    public scannerDevice: MediaDeviceInfo | undefined;
    private lastStringEvent = '';

    constructor(private changeDetectorRef: ChangeDetectorRef,
                private translate: TranslateService,
                private commonFunctions: CommonFunctionsService) {
    }

    ngOnInit() {
        switch (this.type) {
            case 'ser':
                this.allowedFormats = [BarcodeFormat.CODE_39, BarcodeFormat.CODE_128, BarcodeFormat.CODE_93, BarcodeFormat.DATA_MATRIX];
                break;
            case 'ean':
                this.allowedFormats = [BarcodeFormat.EAN_13, BarcodeFormat.EAN_8, BarcodeFormat.UPC_A, BarcodeFormat.UPC_EAN_EXTENSION];
                break;
            case 'inv':
                this.allowedFormats = [BarcodeFormat.ITF];
                break;
        }
        if (this.autoStart) this.doScan();
    }

    ngOnDestroy() {
        this.doStop();
    }

    doScan() {
        this.loading = true;
        this.scannerEnabled = true;
        this.changeDetectorRef.markForCheck();
        // this.changeDetectorRef.reattach();
    }

    doStop() {
        this.scannerEnabled = false;
        this.changeDetectorRef.markForCheck();
        // this.changeDetectorRef.detach();
    }

    camerasFoundHandler(devices: MediaDeviceInfo[]) {
        //console.log('camerasFoundHandler', devices);
        this.loading = false;
        if (devices.length === 1) {
            this.scannerDevice = devices[0];
        } else if (devices.length > 1) {
            let selected = false;
            // selects the device's back camera by default
            for (let i = 0; i < devices.length; i++) {
                if (/back|rear|environment/gi.test(devices[i].label)) {
                    if (!selected) this.scannerDevice = devices[i];
                    selected = true;
                    break;
                }
            }
            if (!selected) this.scannerDevice = devices[0];
        } else {
            this.commonFunctions.showMessage('no camera found');
        }
    }

    scanSuccessHandler(event: string) {
        this.doStop();
        this.code.next(event);
    }

    scanErrorHandler(event: any) {
        // this.doStop();
        let stringEvent = '';
        if (event) stringEvent = event.toString()
        if (stringEvent && (stringEvent !== this.lastStringEvent)) {
            this.lastStringEvent = stringEvent;
            this.commonFunctions.showMessage('barcode scan error', event.toString());
        }
    }
}
